// Shared tree-building helpers for item categories. The API returns a flat
// list (grouped by parentId, root categories have parentId: null) - these
// build the client-side tree used by both the category tree page and the
// item category picker.

export const buildChildrenByParent = (itemCategories) => {
    const byParent = {};

    itemCategories.forEach((category) => {
        const key = category.parentId === null ? 'root' : category.parentId;

        if (!byParent[key]) {
            byParent[key] = [];
        }

        byParent[key].push(category);
    });

    Object.values(byParent).forEach((children) => children.sort((a, b) => a.order - b.order));

    return byParent;
};

export const collectDescendantIds = (itemCategoryId, byParent) => {
    const children = byParent[itemCategoryId] || [];

    return children.reduce((ids, child) => {
        ids.push(child.itemCategoryId);
        return ids.concat(collectDescendantIds(child.itemCategoryId, byParent));
    }, []);
};

export const flattenForSelect = (byParent, disabledIds = [], parentKey = 'root', depth = 0) => {
    const children = byParent[parentKey] || [];

    return children.reduce((options, category) => {
        options.push({
            itemCategoryId : category.itemCategoryId,
            name           : category.name,
            depth          : depth,
            disabled       : disabledIds.includes(category.itemCategoryId)
        });

        return options.concat(flattenForSelect(byParent, disabledIds, category.itemCategoryId, depth + 1));
    }, []);
};
